<template>
    <el-container class="unilateral-static">
        <el-main>
            <div class="unilateral-chart">
                <div class="chart-title column-header">数据统计
                    <el-button class="btn__style" @click="backList"><i class="el-icon-back"></i> 返回</el-button>
                    <el-date-picker size="mini"
                    v-model="dateTimeData"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd HH:mm:ss"
                    @change="dateTimeChange">
                    </el-date-picker>
                </div>
                <div class="unilateral-chart_body">
                    <div class="unilateral-chart_tool">
                        <span class="chart-tool_btn" :class="isCSelected == '1T'?'isSelected': ''" @click="chartDataChange('1T')">1T</span>
                        <span class="chart-tool_btn" :class="isCSelected == '10T'?'isSelected': ''" @click="chartDataChange('10T')">10T</span>
                        <span class="chart-tool_btn" :class="isCSelected == '1H'?'isSelected': ''" @click="chartDataChange('1H')">1H</span>
                        <span class="chart-tool_btn" :class="isCSelected == '1D'?'isSelected': ''" @click="chartDataChange('1D')">1D</span>
                        
                    </div>
                    <MyChartk :chartData="chartDataObj" ref="myChartP"/>
                    <MyChart1 v-if="sid" :sid="sid" 
                    :myChartData="chartDataObj" :timeCycle="isCSelected" ref="myChart"></MyChart1>
                </div>
            </div>

            <div class="user-static-table user-static-item" v-if="retreatData">
                <div class="user-static-table_title">
                    <span class="user-title_name">指标分析</span>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th v-for="(item, index) in tableColumn" :key="'table_'+index">{{item.name}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td v-for="(item, index) in tableColumn" :key="'tbody_'+index">{{indexAnalysis(retreatData[item.key], item.key)}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="user-static-table user-static-item" v-if="retreatData">
                <div class="user-static-table_title">
                    <span class="user-title_name">持仓统计</span>
                </div>
                <el-table style="width: 100%" :data="tableDataP" size="mini">
                    <el-table-column 
                    v-for="(item, index) in tableNameColP" :key="'asset-'+index"
                    :label="item.title" :width="item.width" :prop="item.key">
                    <template slot-scope="scope">
                        <span v-if="item.key == 'type'"
                            :style="{'color': judgeTradeType(scope.row.type)[0]}">
                            {{judgeTradeType(scope.row.type)[1]}}
                        </span>
                        <span v-else-if="item.key == 'position'">{{scope.row[item.key].toFixed(6)}}</span>
                        <span v-else-if="item.key == 'cost'">{{scope.row[item.key].toFixed(2)}}</span>
                        <span v-else>{{scope.row[item.key]}}</span>
                    </template>
                    </el-table-column>
                </el-table>
                <el-pagination background layout="prev, next, total"
                @prev-click="turnPageEvent('last', '2')" @next-click="turnPageEvent('next', '2')"
                :total="this.tableAllData.position_len"></el-pagination>
            </div>

            <div class="user-static-table user-static-item" v-if="retreatData">
                <div class="user-static-table_title">
                    <span class="user-title_name">交易统计</span>
                </div>
                <el-table style="width: 100%" :data="tableDataT" :height="tableHeight">
                    <el-table-column 
                    v-for="(item, index) in tableNameColT" :key="'asset-'+index"
                    :label="item.title" :width="item.width" :prop="item.key">
                    <template slot-scope="scope">
                        <span v-if="item.key == 'type'"
                            :style="{'color': judgeTradeType(scope.row.type)[0]}">
                            {{judgeTradeType(scope.row.type)[1]}}
                        </span>
                        <span v-else-if="item.key == 'price'">
                            {{scope.row[item.key].toFixed(2)}}
                        </span>
                        <span v-else-if="item.key == 'win_lost'">
                            {{addPercentage(scope.row[item.key])}}
                        </span>
                        <span v-else-if="item.key == 'trade_num'">{{scope.row[item.key].toFixed(6)}}</span>
                        <span v-else>{{scope.row[item.key]}}</span>
                    </template>
                    </el-table-column>
                </el-table>
                <el-pagination background layout="prev, next, total"
                @prev-click="turnPageEvent('last', '3')" @next-click="turnPageEvent('next', '3')"
                :total="this.tableAllData.trade_len"></el-pagination>
            </div>
            
            <!-- <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="持仓统计" name="1">
                    <el-table style="width: 100%" :data="tableDataP" :height="tableHeight" size="mini">
                         <el-table-column 
                         v-for="(item, index) in tableNameColP" :key="'asset-'+index"
                         :label="item.title" :width="item.width" :prop="item.key">
                            <template slot-scope="scope">
                                <span v-if="item.key == 'type'"
                                 :style="{'color': judgeTradeType(scope.row.type)[0]}">
                                 {{judgeTradeType(scope.row.type)[1]}}
                                </span>
                                <span v-else>{{scope.row[item.key]}}</span>
                            </template>
                         </el-table-column>
                    </el-table>
                    <el-pagination background layout="prev, next, total"
                    @prev-click="turnPageEvent('last', '2')" @next-click="turnPageEvent('next', '2')"
                    :total="this.tableAllData.position_len"></el-pagination>
                </el-tab-pane>
                <el-tab-pane label="交易统计" name="2">
                    <el-table style="width: 100%" :data="tableDataT" :height="tableHeight">
                         <el-table-column 
                         v-for="(item, index) in tableNameColT" :key="'asset-'+index"
                         :label="item.title" :width="item.width" :prop="item.key">
                            <template slot-scope="scope">
                                <span v-if="item.key == 'type'"
                                 :style="{'color': judgeTradeType(scope.row.type)[0]}">
                                 {{judgeTradeType(scope.row.type)[1]}}
                                </span>
                                <span v-else-if="item.key == 'price'">
                                    {{scope.row[item.key].toFixed(2)}}
                                </span>
                                <span v-else-if="item.key == 'win_lost'">
                                    {{addPercentage(scope.row[item.key])}}
                                </span>
                                <span v-else>{{scope.row[item.key]}}</span>
                            </template>
                         </el-table-column>
                    </el-table>
                    <el-pagination background layout="prev, next, total"
                    @prev-click="turnPageEvent('last', '3')" @next-click="turnPageEvent('next', '3')"
                    :total="this.tableAllData.trade_len"></el-pagination>
                </el-tab-pane>
            </el-tabs> -->
        </el-main>
    </el-container>
</template>

<script>
/* eslint-disable */
import MyChart from "@/components/unilateral/Unilateral-chart.vue";
import MyChart1 from "@/components/user/User-static-chart.vue";
import MyChartk from "@/components/user/User-k-chart.vue";
import { post, get } from "@/api/index";
import { mapState } from 'vuex'
import { getDateTime, getDateRecent } from "@/utils/common";

export default {
    components: {
        MyChart,
        MyChart1,
        MyChartk
    },
    data: function () {
        return {
            sid: '',
            tableNameCol1: [
                {title: 'ID', key: 'id'},
                {title: '总资产', key: 'capital'},
                {title: '可用资金', key: 'cash'},
                {title: '市值', key: 'equity'},
                {title: '收益率', key: 'pct_chg'},
                {title: '时间', key: 'time'},
                // {title: '写入时间', key: 'create_time', width: 140},
            ],
            tableNameColP: [
                // {title: 'ID', key: 'id', width: '60'},
                {title: '币种/合约', key: 'coin_names'},
                {title: '仓位', key: 'position'},
                {title: '成本', key: 'cost'},
                {title: '持仓占比(%)', key: 'ratio'},
                {title: '开仓方向', key: 'type'},
                // {title: '创建时间', key: 'create_time'},
                // {title: '更新时间', key: 'update_time'},
            ],
            tableNameColT: [
                // {title: 'ID', key: 'id', width: '60'},
                // {title: '币种/合约', key: 'coin_names'},
                {title: '交易时间', key: 'create_time', width: 180},
                {title: '成交价', key: 'price', width: 120},
                {title: '成交数量', key: 'trade_num', width: 120},
                {title: '交易类型', key: 'type', width: 80},
                {title: '单笔收益率', key: 'win_lost'}
            ],
            tableColumn: [
                {name: '总资金', key: 'capital'},
                {name: '可用资金', key: 'cash'},
                {name: '市值', key: 'equity'},
                {name: '初始资金', key: 'initial_money'},
                {name: '胜率', key: 'win_rate'},
                {name: '盈亏比', key: 'win_lose_rate'},
                {name: '累计收益', key: 'accumulated_earnings'},
                {name: '交易天数', key: 'len_days'},
                {name: '最大回撤', key: 'max_drawdown'},
                {name: '收益波动率', key: 'return_volatility'},
                {name: '最近交易时间', key: 'last_trading_time'},
            ],
            tableData1: [],
            tableDataP: [],
            tableDataT: [],
            tableHeight: '920',
            activeName: '1',
            chartData: {},
            tableAllData: {},
            retreatData: {},
            startTime: "",
            endTime: "",
            chartDataObj: '',
            isCSelected: '1D',
            chartLoadFlag: true,
            startDateTime: '',
            dateTimeData: '',

        }
    },
    mounted() {
        this.sid = this.$route.query.key;

        if (this.sid) {
            this.getStaticData();
            // this.getChartData();
            this.getRetreatData();
            this.chartDataChange('1D');
        }
    },
    computed: {
        ...mapState([
            'token',
            'userLevel'
        ])
    },
    methods: {
        // get strategy static data
        getStaticData() {
            let url = this.$url_LN_local + '/get/all/data';
            let param = {
                "sign": this.sid,
                "token": this.token
            };

            post(url, JSON.stringify(param)).then(res => {
                if (res.code == 200) {
                    this.tableData1 = res.data.assets;
                    this.tableDataP = res.data.position;
                    this.tableDataT = res.data.trade;
                    this.tableAllData = res.data;
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // Judge the trade type
        judgeTradeType(type) {
            if (type == 1) return ['rgb(218, 86, 52)', '做多'];
            if (type == 2) return ['rgb(218, 86, 52)', '平空'];
            if (type == -1) return ['rgb(26, 179, 148)', '做空'];
            if (type == -2) return ['rgb(26, 179, 148)', '平多'];
        },

        // Tab change event
        handleClick(tab, e) {
            console.log(tab, e)
        },

        // Turning pages
        turnPageEvent(dir, tps) {
            var ids, direction;
            if (dir == 'next') {// next page
                if (tps == '1') {
                    ids = this.tableData1.slice(-1)[0].id;
                } else if (tps == '2') {
                    ids = this.tableDataP.slice(-1)[0].id;
                } else if (tps == '3') {
                    ids = this.tableDataT.slice(-1)[0].id;
                }
                direction = 20;
            } else if (dir == 'last') {// prev page
                if (tps == '1') {
                    ids = this.tableData1[0].id;
                } else if (tps == '2') {
                    ids = this.tableDataP[0].id;
                } else if (tps == '3') {
                    ids = this.tableDataT[0].id;
                }
                direction = -20;
            }

            var param = {
                'sign': this.sid,
                'token': this.token,
                'ids': ids,
                'types': tps,
                'number': direction
            };

            this.getTurnPages(param, tps);
        },

        // get turn pages data
        getTurnPages(param, tps) {
            let url = this.$url_LN_local + '/get/page/data';
            get(url, param).then(res => {
                if (res.code == 200) {

                    if (res.data.length == 0) {
                        this.$notify.error({
                            message: '没有更多数据了!',
                            title: '提示',
                            offset: 100
                        });
                        return;
                    } 

                    if (tps == '1') {
                        this.tableData1 = res.data;
                    } else if (tps == '2') {
                        this.tableDataP = res.data;
                    } else if (tps == '3') {
                        this.tableDataT = res.data;
                    }
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 后退
        backList() {
            this.$router.go(-1);
        },

        // 获取回撤数据
        getRetreatData() {
            var url = this.$url_LN_local + '/retreat/indicators';
            var param = {
                'strategyId': this.sid,
                'token': this.token,
            };

            get(url, param).then(res => {
                if (res.code === 200) {
                    this.retreatData = res.data;
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 300
                    })
                }
            })
        },

        indexAnalysis(data, flag) {
            if (flag == 'win_rate') return data+'%';
            else if (flag == 'accumulated_earnings' || flag == 'max_drawdown') return data+'%';
            return data;
        },

        // 获取api, 策略收益核准数据
        getApiCheckData() {
            var url = this.$url_LN_local + '/earnings/approval';
            var param = {
                token: this.token,
                strategId: '',
                apiId: '',
                startTime: '',
                endTime: ''
            };

            
        },

        // 获取所有图表数据 （新）
        getAllChartData(param) {
            var url = this.$url_LN_local+"/transaction/identifier";
            
            get(url, param).then(res => {
                if (res.code === 200) {
                    this.chartDataObj = res.data;
                    if (this.$refs.myChart) {
                        this.$refs.myChart.setChartLoading('hide');
                        this.$refs.myChartP.chartLoadingEvent('hide');
                    }
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 200
                    })
                }
            })
        },

        // 数据切换
        chartDataChange(flag) {
            this.isCSelected = flag;
            let end_time = getDateTime('date');
            let start_time;

            if (flag == '1T') {
                start_time = getDateRecent(end_time, -1);
            } else if (flag == '10T') {
                start_time = getDateRecent(end_time, -3);
            } else if (flag == '1H') {
                start_time = getDateRecent(end_time, -10);
            } else if (flag == '1D') {
                start_time = getDateRecent(end_time, -30);
            }

            if (this.startTime) {
                start_time = this.startTime;
            };
            console.log('this', this.endTime, '2',end_time);
            if (this.endTime) {
                end_time = this.endTime;
            }
            
            var param = {
                "token": this.token,
                "strategyId": this.sid,
                "startTime": start_time,
                "endTime": end_time,
                "cycle": flag,
            };

            if (this.$refs.myChart) {
                this.$refs.myChart.setChartLoading('show');
            }
            if (this.$refs.myChartP) {
                this.$refs.myChartP.chartLoadingEvent('show');
            }
            this.getAllChartData(param);
        },

        pickerEvent(e) {
            var myDate = new Date(e);  
            var datetime = myDate.format('yyyy-MM-dd hh:ss:mm');   
        },

        // 日期时间选择 事件
        dateTimeChange() {
            this.startTime = new Date(this.dateTimeData[0]).format('yyyy-MM-dd hh:mm');
            this.endTime = new Date(this.dateTimeData[1]).format('yyyy-MM-dd hh:mm');
            this.chartDataChange(this.isCSelected);
        },

        // 添加col百分号
        addPercentage(data) {
            if (data == '--') {
                return data;
            } else {
                return data+'%';
            }
        }
    }
}
</script>

<style lang="scss">
.unilateral-static {
    color: #a8a7a9;
    background-color: #252425;
    width: 1700px;
    margin: auto;
    .is-active {
        background-color: #2a2d2e;
    }

    .el-main {
        // padding-top: 30px;
        background-color: #252425;
        padding-bottom: 10px;
        // max-width: 1200px;
        // margin: 0 50px;

        .unilateral-chart_body {
            .unilateral-chart_tool {
                margin-top: 10px;
                text-align: left;
                padding-left: 50px;
                .chart-tool_btn {
                    padding: 3px 5px;
                    font-size: 12px;
                    border: 1px solid #252425;
                    display: inline-block;
                    vertical-align: middle;
                    margin: 0 5px;
                    box-sizing: border-box;
                    border-radius: 3px;
                    background-color: #252425;
                } 
                .chart-tool_btn:hover {
                    color: #2d71a7;
                    cursor: pointer;
                    border-color: #19405f;
                }
                .chart-tool_btn.isSelected {
                    // border-color: #19405f;
                    color: #2d71a7;
                }

            }
            .unilateral-chart-legend {
                ul li span {
                    width: 18px;
                    height: 12px;
                    background-color: #fff;
                    display: inline-block;
                    vertical-align: middle;
                    border-radius: 1px;
                }
                ul li {
                    display: inline-block;
                    margin: 0 5px;
                    font-size: 12px;
                    vertical-align: middle;
                    line-height: 12px;
                    label {
                        font-size: 12px;
                        display: inline-block;
                        vertical-align: middle;
                        margin-left: 5px;
                    }
                    .unilateral-chart_legend_buy {
                        background-color: #198965;
                    }
                    .unilateral-chart_legend_sell {
                        background-color: #db5634;
                    }
                }
            }
        }

        .user-static-table {
            margin: 20px 0;

            .user-static-table_title {
                text-align: left;
                padding: 10px;
                background-color: #1e1e1e;
            }
            
            table{
                // border: 1px solid #393a3c;
                width: 100%;
                box-sizing: border-box;
                border-spacing: 0;
                background-color: #2a2d2e;
                thead {
                    // background-color: #2a2d2e;
                    th {
                        padding: 5px;
                    }
                }
                tbody {
                    // background-color: #2a2d2e;
                    td {
                        padding: 10px;
                    }
                }
            }
        }

        .unilateral-chart {
            margin-bottom: 30px;
            background-color: #2a2d2e;
            .chart-title {
                background-color: #1e1e1e;
                text-align: left;
                .el-button {
                    margin-left: 10px;
                }
            }
            .el-date-editor {
                background-color: #333333;
                border-color: #333333;
                margin-left: 10px;
            }
            .el-date-editor>.el-range-input {
                    background-color: #333333;
                }
        }

        .el-tabs {
            background-color: #2a2d2e;
            .el-tabs__content {
                padding: 0 10px;
            }
        }

        .el-pagination{
            background-color: #2a2d2e;
        }

        .table-title{
            background-color: #1e1e1e;
            padding: 5px 10px;
            text-align: center;
            border-bottom: 1px solid #3a393a;
            font-size: 14px;
        }
        
        .el-table {
            background-color: #2a2d2e;
            font-size: 12px;
            .el-table__header-wrapper {
                background-color: transparent;
            }
            tr th.is-leaf, td {
                background-color: transparent;
                border-bottom: 1px solid #5a595a;
                padding: 8px 0;
            }

            tr th.is-leaf {
                background-color: #2a2d2e;
            }
            th, tr {
                background-color: transparent;
            }

            tbody {
                tr:hover {
                    background-color: transparent;
                    td {
                        color: #999999;
                        background-color: transparent;
                    }
                }
            }

            tr:nth-child(even) {
                background-color: #262829;
            }
            tr:nth-child(odd) {
                background-color: #2e3538;
            }
        }
        .el-table--border::after, .el-table--group::after, .el-table::before {
            content: '';
            position: absolute;
            background-color: transparent;
            z-index: 1;
        }

        // tab
        .el-tabs__header {
            background-color: #1e1e1e;
            border: none;
        }

        .el-tabs__nav {
            .el-tabs__item {
                border-color: #5a595a;
                color: #a8a7a9;
                border: none;
            }
        }
        .el-tabs__nav-wrap {
            border-color: #5a595a;
        }

        .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
            border-bottom-color: #545151;
            // border: none;
            border-bottom: 1px solid #545151;
        }
        .el-tabs--card>.el-tabs__header .el-tabs__nav{
            border-color: #5a595a;
            border: none;
        }
        .el-tabs--card>.el-tabs__header{
            border-color: #5a595a;
        }
    }

    .footer {
        box-sizing: border-box;
        .name {
            box-sizing: border-box;
        }
    }

    .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
        background-color: #333;
    }
}
</style>
